import { render, staticRenderFns } from "./Kengash.vue?vue&type=template&id=259e6db8&"
import script from "./Kengash.vue?vue&type=script&lang=js&"
export * from "./Kengash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports